import { useState, useContext, useEffect, useMemo } from 'react'
import { PassContext } from '../pass-context'
import _ from "lodash"

import { Typography, TextField, Button, Tooltip } from '@mui/material'
import EastRoundedIcon from '@mui/icons-material/EastRounded'
import PopupShell from '../popup-shell'

const PopupDialogModel = ({ open, close, title, path }) => {

  const { model, setModel } = useContext(PassContext)
  const [newModel, setNewModel] = useState({})

  const dataChanged = useMemo(() => {
    return  open && !_.isEqual(model,newModel)
  },[newModel])

  // Runs on "open" state change or if template / instance data change 
  // Ensures we have the current data rather than something left behind from previous form 
  useEffect(() => {
    try {
      if (open) {
        setNewModel(_.cloneDeep(model))
      }
    }
    catch (err) {
      throw err
    }
  }, [open, path])

  const fieldValue = useMemo(() => {
    return newModel[path] ? newModel[path] : ""
  },[newModel,path])


  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Support Functions
  //////////////////////////////////////////////////////////////////////////////////////////////////////////


  const updateModelValue = value => {
    let m = _.cloneDeep(newModel)
    _.set(m, path, value)
    setNewModel(m)
  }

  const handleClose = (e, reason) => {
    if (reason && reason === "backdropClick")
      return
    close()
  }

  const saveFormData = event => {
    event.preventDefault() // Prevents a "submit" which reloads the page

    // Save content of our "new" template/instance data back to state
    if (!_.isEqual(newModel,model)) setModel(newModel)
    close()
  }


  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Main Render
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  try {
    return (
      <PopupShell open={open} onClose={handleClose}>
        <div className="flex flex-col p-2 h-full w-full overflow-x-hidden">

          <div className="flex flex-row justify-between mt-5">
            <Typography color="secondary" variant="h6">{title}</Typography>
            <Tooltip title="You can press ESC on your keyboard to dismiss"><Button endIcon={<EastRoundedIcon />} onClick={handleClose} >cancel</Button></Tooltip>
          </div>

          <hr />

          <div className='mt-5 overflow-y-scroll flex flex-col gap-5 pt-5'>

            <TextField label={title}
              value={fieldValue}
              slotProps={{ inputLabel: { shrink: true } }}
              type="search"
              onChange={e => updateModelValue(e.target.value)}
            />
          </div>

          <div className='fixed bottom-5 w-[460px]'>
            <hr className='mb-5' />
            <div className="flex flex-row gap-5 justify-end">
              <Button variant="contained" onClick={saveFormData} disabled={!dataChanged}>Save</Button>
            </div>
          </div>

        </div>
      </PopupShell>
    )
  }
  catch (err) {
    throw err
  }
}

export default PopupDialogModel
